import { render, staticRenderFns } from "./hotelCardHome.vue?vue&type=template&id=255695b0&scoped=true&"
import script from "./hotelCardHome.vue?vue&type=script&lang=js&"
export * from "./hotelCardHome.vue?vue&type=script&lang=js&"
import style0 from "./hotelCardHome.vue?vue&type=style&index=0&id=255695b0&lang=sass&scoped=true&"
import style1 from "./hotelCardHome.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255695b0",
  null
  
)

export default component.exports